import { session, appState, EP, THU_IMIE, API_BASE } from '../config.js';
import { fmt } from '../format.js';
import { ICONS, hydrateIcons, svg } from '../icons.js';
import { lineChart } from '../chart.js';
import { DEMO, demoDay } from '../demo.js';
import { apiGet, apiPost, apiPut, noData, imieFor } from '../api.js';
import { C, spinner, emptyRow, toast } from '../ui.js';
import { closeModal } from '../modal.js';
import { go } from '../router.js';
import { applyRole, canDelete } from '../auth.js';

export function renderOpsRows(scope,label,imie,rows){
  const del=canDelete();
  const body=document.getElementById('opsBody');if(!body)return;
  body.innerHTML=rows.length? rows.map(r=>`<tr class="click" onclick="openDetail('${scope}','${label}','${imie}','${r[0]}',${r[1]})">
    <td style="font-weight:600">${r[0]}</td><td><span class="num">${fmt(r[1])}</span>${del?'':'<span class="chev">View<span data-icon="chevron" data-size="14"></span></span>'}</td>
    ${del?`<td><button class="mini del" onclick="event.stopPropagation();confirmDeleteOp('${scope}','${imie}','${r[0]}')"><span data-icon="trash" data-size="15"></span>Delete</button></td>`:''}</tr>`).join('')
    : emptyRow(del?3:2,'No operations recorded yet');
  hydrateIcons(body);
}

export function toolBtns(){return `<button class="btn soft" onclick="handlePrint()"><span data-icon="printer" data-size="16"></span>Print</button>
  <button class="btn soft" onclick="handlePDF()"><span data-icon="filetext" data-size="16"></span>PDF</button>
  <button class="btn soft" onclick="handleExport()"><span data-icon="download" data-size="16"></span>Export</button>`}

export function hintLine(){return `<p style="color:var(--muted);font-size:13px;margin-top:-10px;padding-left:4px;display:flex;align-items:center;gap:6px"><span data-icon="hint" data-size="15"></span>Click any date to view that day's detailed readings.</p>`}

/* DETAIL — conveyorReadingByDate / conveyorReadingEnteredByDate */

export async function openDetail(scope,label,imie,date,total){
  const tbl=scope==='auto'?EP.autoDetail:EP.manualDetail;
  document.getElementById('modalRoot').innerHTML=`
   <div class="modal-overlay" onclick="if(event.target===this)closeModal()"><div class="modal-side">
    <div class="mhead"><h2>${label} Data — ${date}</h2><button class="xclose" onclick="closeModal()" data-icon="close" data-size="20"></button></div>
    <div class="mbody"><div class="btns" style="margin-bottom:16px">
      <button class="btn ghost" onclick="handlePrint()"><span data-icon="printer" data-size="16"></span>Print</button>
      <button class="btn ghost" onclick="handlePDF()"><span data-icon="filetext" data-size="16"></span>PDF</button>
      <button class="btn ghost" onclick="handleExport()"><span data-icon="download" data-size="16"></span>Export</button>
      <span style="margin-left:auto;align-self:center;color:#5a6172;font-size:13px;font-weight:600">Day total: ${fmt(total)}</span></div>
      <div id="detailWrap">${spinner}</div></div></div></div>`;
  ICONS.close='<path d="M18 6 6 18"/><path d="m6 6 12 12"/>';hydrateIcons(document.getElementById('modalRoot'));
  let rows=[];
  try{const r=await apiPost('GetApi.php',{ID:imie,TableName:tbl},{Date1:date});const d=await r.json();if(!noData(d))rows=d}catch(e){appState.OFFLINE=true;applyRole()}
  if(!rows.length)rows=demoDay(date);
  const wrap=document.getElementById('detailWrap');if(!wrap)return;
  wrap.innerHTML=`<table><thead><tr><th>Date</th><th>Time</th><th>ID</th><th>Weight</th></tr></thead><tbody>${
    rows.map(x=>`<tr><td>${x.Date||date}</td><td class="num">${x.Time||''}</td><td class="num">${x.ID||''}</td><td class="num" style="font-weight:600">${x.Weight||''}</td></tr>`).join('')}</tbody></table>`;
}

/* ADD MANUAL ENTRY — LoadConveyorData / LoadConveyorDataTumukunta */

export function confirmDeleteOp(scope,imie,date){
  if(!canDelete())return;
  document.getElementById('modalRoot').innerHTML=`
   <div class="modal-overlay" onclick="if(event.target===this)closeModal()"><div class="modal-center">
    <div class="mbody" style="padding:30px 26px"><div class="confirm-ic" data-icon="trash" data-size="24"></div>
      <div class="confirm-txt">Delete all operation records for <b>${date}</b>?<br>This action cannot be undone.</div>
      <div class="modal-foot" style="justify-content:center"><button class="btn-cancel" onclick="closeModal()">Cancel</button>
      <button class="btn-danger" onclick="deleteOp('${scope}','${imie}','${date}')">Delete</button></div></div></div></div>`;
  hydrateIcons(document.getElementById('modalRoot'));
}

export async function deleteOp(scope,imie,date){
  const table=scope==='thu'?'DeleteTumukunta':'DeleteShamshabad';
  try{await apiPost('https://norisapi.noris.in/ERP/PostApi.php',{ID:imie,TableName:table},{FromDate:date});}catch(e){/* offline */}
  closeModal();
  go(scope==='auto'?'auto':scope==='sha'?'manual-sha':'manual-thu');
  toast('Operation records deleted');
}

/* ============================================================
   PLANT PROCESSING  —  ShowLoadConveyorData {FromDate,ToDate}
   ============================================================ */
